// prefer default export if available
const preferDefault = m => m && m.default || m

exports.components = {
  "component---src-templates-result-js": () => import("./../src/templates/result.js" /* webpackChunkName: "component---src-templates-result-js" */),
  "component---src-pages-404-js": () => import("./../src/pages/404.js" /* webpackChunkName: "component---src-pages-404-js" */),
  "component---src-pages-index-js": () => import("./../src/pages/index.js" /* webpackChunkName: "component---src-pages-index-js" */),
  "component---src-pages-lotoplus-js": () => import("./../src/pages/lotoplus.js" /* webpackChunkName: "component---src-pages-lotoplus-js" */),
  "component---src-pages-quini-6-js": () => import("./../src/pages/quini6.js" /* webpackChunkName: "component---src-pages-quini-6-js" */),
  "component---src-pages-quiniela-js": () => import("./../src/pages/quiniela.js" /* webpackChunkName: "component---src-pages-quiniela-js" */),
  "component---src-pages-totobingo-js": () => import("./../src/pages/totobingo.js" /* webpackChunkName: "component---src-pages-totobingo-js" */)
}

